import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Papa from 'papaparse';

import { hideDownloadCsvModal } from '../../actions';

class DownloadCsvModal extends Component {
    render() {
        const { show, mediaItems, scene, hideDownloadCsvModal} = this.props;

        let downloadLink = '';
        let downloadName = '';

        if (show) {
            const csvText = Papa.unparse(mediaItems.map(item => ({
                sourcePath: item.sourcePath,
                sourceRepository: item.sourceRepository,
                sceneMediaID: item.sceneMediaID,
                sceneName: item.sceneName,
                datasetNum: item.datasetNum,
                mediaName: item.mediaName,
                language: item.language,
                description: item.description
            })), {});
            // UTF-8 BOM plus the text from papa
            const payload = new Blob(["\uFEFF",...csvText], {type: 'text/csv'});

            downloadLink = window.URL.createObjectURL(payload);
            downloadName = `${scene}.csv`;
        }
        
        return (
            <Modal show={show} onHide={hideDownloadCsvModal}>
                <Modal.Header closeButton>
                    <Modal.Title> Download CSV </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <a href={downloadLink} download={downloadName}>{downloadName}</a>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    const scene = state.scene.current;
    const sceneMedia = state.mediaByScene[scene];
    const mediaItems = sceneMedia ? sceneMedia.mediaItems : [];
    const show = state.ui.downloadCsv.show;

    return {
        mediaItems,
        scene,
        show
    };
};

const mapDispatchToProps = {
    hideDownloadCsvModal
};

DownloadCsvModal.propTypes = {
    mediaItems:           PropTypes.array,
    scene:                PropTypes.string.isRequired,
    show:                 PropTypes.bool.isRequired,
    hideDownloadCsvModal: PropTypes.func.isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadCsvModal);



// WEBPACK FOOTER //
// ./src/components/csv/DownloadCsvModal.js